<div class="trial-screen">
    <div class="trial-screen-left">
        <div class="left-wrapper">
            <div class="left-container">
                <div class="logo-container">
                    <img [src]="'images/login-browsi-logo.png' | assetVersion" alt="Browsi Logo" class="logo">
                    <span class="logo-text">InsightHub</span>
                </div>
                <div class="branding-content-container">
                    <div class="branding-image"
                         [style.background-image]="'url(' + ('images/sign-up.png' | assetVersion) + ')'">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="trial-screen-right">
        <div class="mobile-logo" *ngIf="currentStep === TrialStep.REGISTER_EMAIL">
            <img [src]="'images/browsi-logo-mobile.png' | assetVersion" alt="Browsi Logo">
        </div>
        <app-trial-step-indicator 
            *ngIf="currentStep > TrialStep.REGISTER_EMAIL && currentStep <= TrialStep.COMPLETE"
            [currentStep]="currentStep">
        </app-trial-step-indicator>
        <app-register-trial-email 
            *ngIf="currentStep === TrialStep.REGISTER_EMAIL"
            [firstNameControl]="firstNameControl"
            [lastNameControl]="lastNameControl"
            [emailControl]="emailControl"
            [enforceGoogleSignup]="isGoogleRegisteredUser"
            (nextStep)="onNextStep()"
            (googleSignupSuccess)="onGoogleSignupSuccessed()">
        </app-register-trial-email>
        <div class="step-two-wrapper" *ngIf="currentStep === TrialStep.SELECT_BRAND">
            <app-trial-step-two 
                [firstName]="firstNameControl.value || ''"
                (nextStep)="onNextStep()">
            </app-trial-step-two>
        </div>
        <app-trial-step-three 
            *ngIf="currentStep === TrialStep.PROFILE" 
            [companyNameControl]="companyNameControl"
            [jobTitleControl]="jobTitleControl"
            [jobTitleItems]="jobTitleItems"
            [firstName]="firstNameControl.value || ''"
            (nextStep)="onNextStep()">
        </app-trial-step-three>
        <app-trial-step-four 
            *ngIf="currentStep === TrialStep.COMPLETE" 
            [firstName]="firstNameControl.value || ''"
            [email]="emailControl.value || ''"
            (nextStep)="onNextStep()">
        </app-trial-step-four>
    </div>
</div>

